@if (tree) {
    <div class="field-picker-tree-style-wrapper">
        <label class="label-title">Available Fields</label>

        <div class="search-box" [ngClass]="{'readonly': readonly}">
            <span class="icon-search1"></span>

            <input
                type="search"
                placeholder="Search"
                autocomplete="off"
                [(ngModel)]="searchValue"
                (ngModelChange)="searchMetadata()"/>
        </div>

        <div class="property-list">
            @for (data of tree; track $index) {
                @if (!data.hidden) {
                    <div class="parent-field">
                        @if (!data.children.length && !data.displayData[0].hierarchy) {
                            <div
                                class="list-item"
                                [title]="data.displayName"
                                [innerHtml]="data.displayName | highlight: searchValue"
                                cdkDrag
                                [cdkDragData]="data"
                                (cdkDragStarted)="dragStateChanged.emit({ state: 'start', data })"
                                (cdkDragEnded)="dragStateChanged.emit({ state: 'stop', data })">
                            </div>
                        } @else {
                            <ng-container>
                                <span
                                    [ngClass]="data.isCollapsed ? 'icon-arrow-right' : 'icon-expand'"
                                    title="{{ data.isCollapsed ? 'icon-arrow-right' : 'icon-expand' }}"
                                    (click)="data.isCollapsed = !data.isCollapsed">
                                </span>

                                <div class="list-item grid-list-item" [title]="data.displayName">{{ data.displayName }}</div>
                            </ng-container>

                            @if (!data.isCollapsed) {
                                <div class="grid-list-children">
                                    @if (data.children.length) {
                                        <ng-container *ngTemplateOutlet="childElems; context: {ctx: data}"></ng-container>
                                        @if (data.displayData.length) {
                                            <ng-container
                                                *ngTemplateOutlet="lastChild;context: {dataList: data.displayData}">
                                            </ng-container>
                                        }
                                    } @else {
                                        <ng-container *ngTemplateOutlet="lastChild; context: {dataList: data.displayData}"></ng-container>
                                    }
                                </div>
                            }
                        }
                    </div>
                }
            }
        </div>
    </div>
}

<!-- Templates defined -->
<ng-template #childElems let-ctx="ctx">
    @for (child of ctx.children; track $index) {
        @if (!child.hidden) {
            <div class="child-field">
                <span
                    [ngClass]="child.isCollapsed ? 'icon-arrow-right' : 'icon-expand'"
                    title="{{ child.isCollapsed ? 'icon-arrow-right' : 'icon-expand' }}"
                    (click)="child.isCollapsed = !child.isCollapsed">
                </span>

                <div class="list-item grid-list-item" [title]="child.displayName">{{ child.displayName }}</div>
            </div>
        }

        @if (!child.isCollapsed) {
            <div class="grid-list-children">
                @if (child.children.length) {
                    <ng-container *ngTemplateOutlet="childElems;context: {ctx: child}"></ng-container>
                    @if (child.displayData.length) {
                        <ng-container *ngTemplateOutlet="lastChild;context: {dataList: child.displayData}"></ng-container>
                    }
                } @else {
                    <ng-container *ngTemplateOutlet="lastChild;context: {dataList: child.displayData}"></ng-container>
                }
            </div>
        }
    }
</ng-template>

<ng-template #lastChild let-dataList="dataList">
    @for (data of dataList; track $index) {
        <div cdkDropList [cdkDropListEnterPredicate]="dropListEnterPredicate()" [ngClass]="{'readonly': readonly}">
            @if (!data.hidden) {
                <div
                    class="list-item list-child"
                    [title]="data.displayName"
                    [innerHtml]="data.displayName | highlight: searchValue"
                    cdkDrag
                    [cdkDragData]="data"
                    [cdkDragDisabled]="readonly"
                    (cdkDragStarted)="cloneElement($event, { state: 'start', data })"
                    (cdkDragEnded)="dragStateChanged.emit({ state: 'stop', data })"
                    (dblclick)="doubleClick.emit(data)">
                </div>
            }
        </div>
    }
</ng-template>
<!-- Templates defined -->
